import { render, staticRenderFns } from "./admin_qyxw.vue?vue&type=template&id=0dd84a72&scoped=true"
import script from "./admin_qyxw.vue?vue&type=script&lang=js"
export * from "./admin_qyxw.vue?vue&type=script&lang=js"
import style0 from "./admin_qyxw.vue?vue&type=style&index=0&id=0dd84a72&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd84a72",
  null
  
)

export default component.exports